import { createWebHistory, createRouter } from "vue-router";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import PagoResultSection from "@/components/PagoResultSection.vue";
import AcreditadoSection from "@/components/AcreditadoSection.vue";
import PagarSection from "@/components/PagarSection.vue";

const routes = [
  {
    path: "/",
    component: AcreditadoSection,
  },
  {
    path: "/pagar/:hash",
    component: PagarSection,
  },
  {
    path: "/finalizado",
    name: "Finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
   {
    path: "/descarga",
    name: "Credencial",
    component: PagoResultSection,
   },
   
];

import { createWebHashHistory } from 'vue-router'



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;